import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Evaluation from './pages/Evaluation';
import FormPage from './pages/Formpage';
import CommentContext from './context/CommentContext';

import { ThemeProvider, CssBaseline } from '@mui/material';

import theme from './style/theme';

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title
    });
  }, [location]);

  return null;
}

function App() {
    const [comments, setComments] = useState(null);

    return (
        <ThemeProvider theme={theme}>
        <CssBaseline />
        <CommentContext.Provider value={{ comments, setComments }}>
            <Router>
            <PageViewTracker />
            <Routes>
                <Route path="/evaluation" element={<Evaluation />} />
                <Route path="/" element={<FormPage />} />
            </Routes>
            </Router>
        </CommentContext.Provider>
        </ThemeProvider>
    );
    }


export default App;
